import styles from '@/styles/category/filter-item.module.scss'
import { useState } from 'react'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';

// 定义分类项接口
interface sideFilterItem {
  name: string;
  description?: string;
  count?: number;
  minPrice?: number | null;
  maxPrice?: number | null;
}

interface Props {
  filterTypeItem: {
    title: string;
    key: string;
    currentItemName?: string;
    items: sideFilterItem[]
  };
  onItemSelect: (_filterKey: string, _itemName: string) => void; // 通知父组件 请求接口修改数据
}

export default function CategoryFilterItem({ filterTypeItem, onItemSelect }: Props) {
  const [showMore, setShowMore] = useState(false);

  // 切换是否展示更多
  const toggleShowMore = () => {
    setShowMore(!showMore)
  };

  // 点击事件
  const handleSelectItem = (item: sideFilterItem) => {
    // 如果提供了 onItemSelect 回调函数，则通知父组件
    if (onItemSelect) {
      onItemSelect(filterTypeItem.key, item.description ? item.name + item.description : item.name)
    }
  };

  return (
    <>
      {
        !!(filterTypeItem && filterTypeItem.items && filterTypeItem.items.length) &&
        <div className={styles['comp-filter-item']}>
          <div className={styles['title']}>{filterTypeItem.title}</div>

          <div className={`${styles['item-list']} ${showMore ? styles['item-list-all'] : ''}`}>
            {
              filterTypeItem.items.map((item: sideFilterItem, index: number) => (
                <div className={styles['item']} key={filterTypeItem.key + index}>
                  <div 
                    className={`
                      ${styles['item-name']} 
                      ${(item.description ? filterTypeItem?.currentItemName == item.name + item.description : filterTypeItem?.currentItemName == item.name) ? styles['active'] : ''}
                    `}
                    onClick={() => handleSelectItem(item)}
                  >
                    {item.name}
                    {
                      !!(item?.description) &&
                      <span className={styles['item-description']}>&nbsp;({item.description})</span>
                    }
                  </div>
                </div>
              ))
            }
          </div>

          {
            !!(filterTypeItem.items.length > 10) &&
            <div className={styles['show-more-btn']} onClick={toggleShowMore}>
              Show More&nbsp;
              {
                showMore ?
                <CaretUpOutlined
                  color={'#999999'}
                  style={{ marginTop: '2px' }}
                />
                :
                <CaretDownOutlined
                  color={'#999999'}
                  style={{ marginTop: '2px' }}
                />
              }
            </div>
          }
        </div>
      }
    </>
  )
}